webpackJsonp([28313394369846],{

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BuyPage = function BuyPage() {
	  return _react2.default.createElement(
	    "section",
	    { className: "main wrapper style2" },
	    _react2.default.createElement(
	      "header",
	      { className: "major" },
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Purchase Strategeist"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "section",
	        null,
	        _react2.default.createElement(
	          "header",
	          null,
	          _react2.default.createElement(
	            "h3",
	            null,
	            "System Requirements"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-6 col-6-narrow col-12-mobile" },
	            _react2.default.createElement(
	              "ul",
	              null,
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Processor:"
	                ),
	                " 2 GHz"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "OS:"
	                ),
	                " Windows 7/8/10 64-bit",
	                ' '
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "RAM:"
	                ),
	                " 8 GB"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Video Card:"
	                ),
	                " 1 GB"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Hard Disk Space:"
	                ),
	                " 2 GB",
	                ' '
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "section",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "Strategeist is currently in closed beta. You will be asked to sign a non-disclosure agreement before being granted access. If you would like to join, please fill out the form below."
	        ),
	        _react2.default.createElement(
	          "form",
	          {
	            name: "beta-form",
	            "data-netlify": "true",
	            "data-netlify-honeypot": "bot-field",
	            method: "post"
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "row gtr-uniform gtr-50" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              _react2.default.createElement("input", { type: "text", name: "name", placeholder: "Name" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              _react2.default.createElement("input", { type: "email", name: "email", placeholder: "Email" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              "Any experience with strategy games?",
	              _react2.default.createElement("textarea", { name: "experience" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              "Why would you like to join the beta?",
	              _react2.default.createElement("textarea", { name: "why" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              _react2.default.createElement(
	                "ul",
	                { className: "actions" },
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement("input", { type: "submit", value: "Sign up", className: "primary" })
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = BuyPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-buy-js-98e878ca1fcfd51f0003.js